/* Language selection stays within navigation and preserves the selected product. */
(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.korner-language[open]').forEach(function (menu) {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.korner-language[open]').forEach(function (menu) {
      menu.open = false;
      if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('.korner-language__form')) return;
    var destination = form.querySelector('input[name="return_to"]');
    if (destination) destination.value = location.pathname + location.search;
    var button = event.submitter;
    if (button && button.name === 'language_code') {
      try { localStorage.setItem('translation-lab-lang', button.value); } catch (error) {}
    }
  });
})();
